import {FC} from 'react'

import {ResourceSubmenuItem} from '@/content/header'
import {theme} from '@/theme/theme'

import {HelpCenterButton} from '../help-center/HelpCenterButton'
import {HeaderNavigation} from './HeaderNavigation'
import {MobileNavigation} from './MobileNavigation'
import {RegionalSettings} from './regional-settings/RegionalSettings'

type MainHeaderMobileNavigationProps = {
  isActive: boolean
  setIsActive: (value: boolean) => void
  resourcesSubmenuItems?: ResourceSubmenuItem[]
  hasRegionalSettings?: boolean
  hasGetHelpButton?: boolean
}

export const MainHeaderMobileNavigation: FC<MainHeaderMobileNavigationProps> = ({
  isActive,
  setIsActive,
  resourcesSubmenuItems,
  hasRegionalSettings = true,
  hasGetHelpButton = true,
}) => {
  const closeMobileNavigation = () => setIsActive(false)

  return (
    <>
      <MobileNavigation isActive={isActive} toggleNavigation={() => setIsActive(!isActive)}>
        <HeaderNavigation
          isMobile
          closeMobileNav={closeMobileNavigation}
          resourcesSubmenuItems={resourcesSubmenuItems}
        />
        <div className="actions">
          {(hasRegionalSettings || hasGetHelpButton) && (
            <div className="buttons">
              {hasRegionalSettings && (
                <div className="button-wrapper">
                  <RegionalSettings hasBorder onClose={closeMobileNavigation} />
                </div>
              )}
              {hasGetHelpButton && (
                <div className="button-wrapper">
                  <HelpCenterButton onClick={closeMobileNavigation} />
                </div>
              )}
            </div>
          )}
        </div>
      </MobileNavigation>

      <style jsx>{`
        .actions {
          display: flex;
          flex-direction: column;
          gap: ${theme.spacing[3]};
          margin-top: ${theme.spacing[3]};
        }
        .buttons {
          display: flex;
          gap: ${theme.spacing[3]};
        }
        .button-wrapper {
          flex: 1;
        }
      `}</style>
    </>
  )
}
